import React from 'react';
import {
    Form,
    Input,
    Col,
    Row,
    Pagination,
    Select,
    Radio,
    message,
    Tree,
    Popconfirm,
    Icon,
    Upload,
    DatePicker
} from 'antd';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import { commonIsMap, dicProjectStatus } from '../../../../axios/dictionaries';
import FileUpload from '../../../../components/FileUpload';
import moment from "moment";

const Option = Select.Option;
const RadioGroup = Radio.Group;
const { TreeNode } = Tree;

class Page extends React.Component {


    constructor() {



        super();
        this.state = {
            loading: false,
            title: '新增项目',
            data: {},
            merchantData: [],
            contractData: [],
            newContractData: [],
            buildingData: [],
            current: 1, //合同分页
            modalData: {
                attachList: {}
            },
            pageSize: 5,
            radioClarifyValue:false,
            selectJhValue:false,
            isDevice: false,
            leaseTermTime: {}, //起租日-退租日
            checkedKeys: [], //选中的房源
        }
    }

    uploadEnclosure = (name, res) => { //上传附件
        let { modalData } = this.state;
        modalData.attachList = [{ name, id: res.attach_id, url: res.attach_url }];
      //  modalData.fileUrl = res.attach_url
        this.setState({ modalData });
    }

    handleJhChange = (e) => { // 是否开启建行
        //
        // const selectJhValue = e===1?true:false
        // this.setState({
        //     selectJhValue
        // })
    }


    handleClarifyChange = (e) => { // 是否清算修改
        const radioClarifyValue = e.target.value
        this.setState({
            radioClarifyValue
        })
    }

    handleDeleteAttach = (index) => { //删除附件
        let { modalData } = this.state;
        modalData.attachList.splice(index, 1);
        this.setState({ modalData });
    }

    render() {
        let { visible, form: { getFieldDecorator, getFieldValue,setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
            contractData,
            merchantData,
            buildingData,
            modalData,
            checkedKeys,
        } = this.state;



        return <ModalDom
            title={title}
            width={"1000px"}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
               >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <DetailTitle title="基本信息" boxStyle={{ marginTop: '0' }} />
                    <CustomRow>
                        <CustomCol label="商户名称">
                            {getFieldDecorator('merchantId', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.merchantId
                            })(
                                <Select
                                    showSearch
                                    // style={{ width: 275 }}
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                    onChange={(value) => {
                                        this.pullHouseMessage(value,null);
                                    }}
                                >
                                    {merchantData.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                        <CustomCol label="项目编号">
                            {getFieldDecorator('projectNo', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.projectNo
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                // style={{ width: 274 }}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="账单对接建行">
                            {getFieldDecorator('isJr', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.isJr || 2
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                    onChange={this.handleJhChange}
                                >
                                    {commonIsMap.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="项目名称">
                            {getFieldDecorator('name', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.name
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                // style={{ width: 275 }}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="发布状态">
                            {getFieldDecorator('status', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.status || 1
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                >
                                    {dicProjectStatus.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                    </CustomRow>
                    {
                        this.state.isDevice
                            ?
                            <CustomRow divider>
                                <CustomCol label="运营开始时间">
                                    {getFieldDecorator('beginDate', {
                                        rules: [{
                                            required: true, message: '请选择',
                                        }],
                                        initialValue: data.operationStartDate ? moment(data.operationStartDate) : null
                                    })(
                                        <DatePicker
                                            placeholder={'请选择'}
                                            allowClear={false}
                                            onChange={(date) => {
                                                let {leaseTermTime: {end}} = this.state;
                                                this.setState({leaseTermTime: {start: date, end}});
                                            }}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="运营结束时间">
                                    {getFieldDecorator('endDate', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.operationEndDate ? moment(data.operationEndDate) : null
                                    })(
                                        <DatePicker
                                            placeholder={'请选择'}
                                            allowClear={false}
                                            onChange={(date) => {
                                                let {leaseTermTime: {start}} = this.state;
                                                this.setState({leaseTermTime: {start, end: date}});
                                            }}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>:null
                    }

                    <DetailTitle title="电子合同" />
                    <Form.Item style={{ margin: 0, padding: 0 }}>
                        {getFieldDecorator('contractTemplateId', {
                            rules: [{
                                required: true, message: '请选择电子合同',
                            }],
                            initialValue: data.contractTemplateId
                        })(
                            <RadioGroup style={{ display: 'block' }}>
                                <div className="tableBox">
                                    <div className="tableTitle">
                                        <div style={{ flex: '0 0 100px' }}>选择</div>
                                        <div style={{ flex: 1 }}>合同编号</div>
                                        <div style={{ flex: 1 }}>合同名称</div>
                                        <div style={{ flex: 1 }}>操作</div>
                                    </div>
                                    <div className="tableBody">
                                        {
                                            this.state.newContractData.length
                                                ? this.state.newContractData.map((item, index) => {
                                                    if (item) {
                                                        return <label className="tableBodyRow" key={index}>
                                                            <div style={{ flex: '0 0 100px', alignItems: 'center' }}><Radio value={item.id} /></div>
                                                            <div style={{ flex: 1 }}>{item.templateNo}</div>
                                                            <div style={{ flex: 1 }}>{item.name}</div>
                                                            <div style={{ flex: 1 }}>
                                                                <a className="showClickDetail" target="_black" href={item.fileUrl}>查看合同</a>
                                                            </div>
                                                        </label>
                                                    }
                                                })
                                                : <div className="tableBodyRow" style={{ justifyContent: 'center' }}>暂无数据</div>
                                        }
                                    </div>
                                </div>
                            </RadioGroup>
                        )}

                        {
                            contractData.length
                                ? <div style={{ padding: '10px 0', textAlign: 'right' }}>
                                    <Pagination
                                        showTotal={
                                            (total, range) => {
                                                let contractTemplate = getFieldValue('contractTemplateId');
                                                for (let i = 0; i < contractData.length; i++) {
                                                    if (contractData[i].id === contractTemplate) {
                                                        contractTemplate = contractData[i].name;
                                                        break;
                                                    }
                                                }
                                                return (
                                                    <span>
                                                        共{total}个合同模板
                                                                ； {
                                                            contractTemplate === undefined
                                                                ? '当前未选择'
                                                                : <span>
                                                                    <b>已选择：{contractTemplate}</b>
                                                                </span>
                                                        }
                                                    </span>
                                                )
                                            }
                                        }
                                        size="small"
                                        current={this.state.current}
                                        pageSize={this.state.pageSize}
                                        onChange={this.onChange}
                                        total={contractData.length}
                                    />
                                </div>
                                : null
                        }
                    </Form.Item>
                    <DetailTitle title="项目房源" />
                    {
                        buildingData.length
                            ? <Tree
                                multiple
                                checkable
                                onCheck={
                                    (checkedKeys) => {
                                        this.setState({ checkedKeys });
                                    }
                                }
                                checkedKeys={checkedKeys}
                              >
                                {this.renderTreeNodes(buildingData)}
                            </Tree>
                            : <div style={{ textAlign: 'center' }}>暂无数据</div>
                    }
                    <DetailTitle title="附件" />
                    <FileUpload hideLabel ref={(ref) => this.fileUploadRef = ref} tableName="project" rowId={this.state.projectId} fileTypeList={[14]} />
                    <div style={{ color: 'red', lineHeight: '30px' }}>注：房源关联项目后，租客支付该房源的账单都由中和智家信息代收</div>
                </Form>
            </div>
        </ModalDom >
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    initPack() {
        postFrom({
            url: config.API_merchant_findAll,
            data: {}
        }).then(res => {
            let merchantData = res.map(item => ({ title: item.shortName, value: item.id, name: item.name,isJr:item.isJr,zjbDataSync:item.zjbDataSync,isDeviceLease: item.isDeviceLease  }));
            this.setState({ merchantData });
        }).catch(err => {
            message.error(err.message || '获取商户列表失败');
            this.setState({ loading: false });
        });
        this.handleSystemGetContract();
    }

    loadPack = ({ id }) => {
        this.projectId = id;
        this.setState({ loading: true, title: "编辑项目", projectId: id });
        let data = { projectId: id };
        postFrom({ url: config.API_project_getById, data }).then(res => {
            this.setState({ data: { ...res, id },radioClarifyValue: (res.clarify==null?false:res.clarify==1?true:false),selectJhValue:(res.isJr==null?false:res.isJr==1?true:false), loading: false});

            if (res.houseContractUrl) {

                let { modalData } = this.state;

                modalData.attachList= [{ url: res.houseContractUrl,id:0,name: res.houseContractName}];
                this.setState({ modalData });

            }
            this.pullHouseMessage(res.merchantId,res.isJh);
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
        this.loadAsyncFileUploadRef()
    }
    loadAsyncFileUploadRef = () => {
        if (this.fileUploadRef){
            this.fileUploadRef.postFileList()
        } else {
            setTimeout(() => {
                this.loadAsyncFileUploadRef()
            }, 50);
        }
    }

    pullHouseMessage = (merchantId,jh) => { //拉取房源信息

       let merchantInfo = this.state.merchantData.find(item => item.value === merchantId);

       debugger
        if((merchantInfo&&merchantInfo.isDeviceLease!=null&&merchantInfo.isDeviceLease===1)) {
            this.setState({isDevice: true});
        }else {
            this.setState({isDevice: false});
        }


       if((merchantInfo&&merchantInfo.isJr!=null&&merchantInfo.isJr===1)||(jh!=null&&jh===1)) {
           this.setState({selectJhValue: true});

       }else {
           this.setState({selectJhValue: false});
       }

        this.setState({ loading: true });
        postFrom({
            url: config.API_building_findBuildingList, data: {
                merchantId
            }
        }).then(res => {
            this.setState({ buildingData: res, loading: false }, () => {
                for (let i = 0; i < res.length; i++) {
                    this.handleGetFloor(res[i].id)
                }
            });
        }).catch(err => {
            message.error(err.message || '获取房源（小区/楼栋）列表失败');
            this.setState({ loading: false });
        });
    }

    handleSystemGetContract = () => {
        this.setState({ loading: true });
        postFrom({ url: config.API_contracttemplate_findAllContractTemplate, data: {} }).then(res => {
            this.setState({ contractData: res, loading: false }, this.onChange.bind(this, 1));
        }).catch(err => {
            message.error(err.message || '获取系统预定义电子合同列表失败');
            this.setState({ loading: false });
        });
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {}, contractData: [], newContractData: [], buildingData: [], checkedKeys: [],selectJhValue:false,isDevice: false, loading: false,modalData:{attachList:[]}, title: '新增项目', });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                values.merchantName = this.state.merchantData.find(item => item.value === values.merchantId); //处理商户
                values.merchantName = values.merchantName ? values.merchantName.name : '';
                let projectHouses = this.state.data.projectHouses;
                let attachList=this.state.modalData.attachList;
                let isHouse = projectHouses instanceof Array; //确定有房源数组
                let houseId = this.state.checkedKeys.filter(item => item.startsWith('houseId')); //删除选中的房源数据
                houseId = houseId.map(item => {
                    item = +item.slice(7);
                    if (isHouse) {
                        let house = projectHouses.find(items => items.houseId === item); //当前房源是否被选中
                        if (house) {
                            return { id: house.id, houseId: item }
                        }
                        return { houseId: item }
                    } else {
                        return { houseId: item }
                    }
                });
                values.projectHouses = houseId;
                values.clarify=this.state.radioClarifyValue?1:2;
                values.operationStartDate  =this.state.leaseTermTime.start;
                values.operationEndDate = this.state.leaseTermTime.end;
                values.houseContractUrl= Array.isArray(attachList) ? attachList.map(item => item.url).join('|') : '',
                    values.houseContractName = Array.isArray(attachList) ? attachList.map(item => item.name).join('|') : '',
                    this.setState({ loading: true });
                if (values.id) {
                    post({ url: config.API_project_edit, data: values }).then(res => {
                        message.success('编辑成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '编辑失败');
                        this.setState({ loading: false });
                    })
                } else {
                    post({ url: config.API_project_create, data: values }).then(res => {
                        message.success('新增成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '新增失败');
                        this.setState({ loading: false });
                    })
                }
            }
        })
    }

    renderTreeNodes = data => {
        return data.map(item => {
            if (item.children) {
                return (
                    <TreeNode selectable={false} title={item.name} key={item.id} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode selectable={false} title={item.name} key={item.id} dataRef={item} isLeaf={item.isChild} />;
        })
    }

    handleGetFloor = (buildingId) => {
        postFrom({ url: config.API_project_findBuildingHouseList, data: { buildingId } }).then(res => {
            let { data: { projectHouses }, checkedKeys, buildingData } = this.state;
            let existing = []; //存放当前项目关联的房源
            if (projectHouses instanceof Array) {
                existing = projectHouses.filter(item => +item.buildingId === buildingId);
            }
            let arr = [].concat(existing, res); //连接被关联的房源与未被关联的房源
            arr.sort((a, b) => a.floor - b.floor); //针对楼层排序
            let floor = [];
            arr.forEach(el => { //生成出分楼层房号的数组
                let value = floor.find(item => item.name === `楼层：${el.floor}`);
                if (value) {
                    value.children.push({ name: `房号：${el.roomNo}`, id: `houseId${el.houseId}`, isChild: true })
                } else {
                    floor.push({
                        name: `楼层：${el.floor}`,
                        id: `${el.houseId}·${el.floor}`,
                        children: [
                            { name: `房号：${el.roomNo}`, id: `houseId${el.houseId}`, isChild: true }
                        ]
                    })
                }
            });
            floor.forEach((el => { //针对房号排序
                el.children.sort((a, b) => a.name.slice(3) - b.name.slice(3));
            }));
            let nowBuilding = buildingData.find(item => item.id === buildingId);
            nowBuilding ? nowBuilding.children = floor : null;
            for (let i = 0; i < existing.length; i++) { //加入已被关联房源的选中
                if (checkedKeys.indexOf(`houseId${existing[i].houseId}`) === -1) {
                    checkedKeys.push(`houseId${existing[i].houseId}`);
                }
            }
            this.setState({ buildingData, checkedKeys });
        }).catch(err => {
            message.error(err.message || '获取未关联房源列表失败');
        });
    }

    onChange = page => { //改变分页
        let { contractData, newContractData, pageSize } = this.state;
        newContractData = contractData.slice((page - 1) * pageSize);
        if (newContractData.length > pageSize) {
            newContractData = newContractData.slice(0, pageSize);
        }
        this.setState({ current: page, newContractData })
    };
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/RentContract/components/ProjectAdd/index.js